import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import useAPI from "../../../../../../../api/hooks/useAPI";
import { ComplexEntityTypes } from "../../../../../../../utils/constants";
import IntegrationImage from "../../../../../integrations/components/IntegrationImage";
import { useEntities } from "../../../../hooks/useEntities";
import EntityDrawer from "../../../EntityDrawer/EntityDrawer";
import TextIntegrationStyle from "../../../TextIntegrationStyle";

const HostUsersView = ({ entityData }) => {
  const topConsoleUser = entityData?.microsoft_sccm_data?.top_console_user;
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false);
  const { useQueryForEntitiesByType } = useEntities();
  const { trackEvent } = useAPI();

  const { data: userEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.USER,
  });

  const connectedUserEntity = useMemo(() => {
    if (!userEntities || !entityData?.user_email) return null;
    return userEntities.find(
      (entity) => entity.unique_id === entityData?.user_email
    );
  }, [userEntities, entityData?.user_email]);

  const onUserEmailClick = () => {
    trackEvent(
      `User clicked on user email ${entityData?.user_email}, from host users view ${entityData?.display_name}`
    );
    setIsUserDrawerOpen(true);
  };

  if (!topConsoleUser && !entityData?.user_email) {
    return null;
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.user_email && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Connected Users</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.connected_user_name ||
                entityData?.user_display_email ||
                entityData?.user_email
              }
              onClick={() => onUserEmailClick()}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
              tooltipTitle={"Click to view user details"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {topConsoleUser && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2">Top Console User</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"microsoft_sccm"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={topConsoleUser}
            />
          </Box>
        </Box>
      )}
      <EntityDrawer
        openDrawer={isUserDrawerOpen && connectedUserEntity}
        selectedEntity={connectedUserEntity}
        onClose={() => {
          setIsUserDrawerOpen(false);
        }}
      />
    </Box>
  );
};

export default HostUsersView;
